import { Box, Text, useTheme } from '@ltvco/refresh-lib/theme';
import { useState } from 'react';

type MenuItemProps = {
  label: string;
  onClick: () => void;
};

export const MenuItem = ({ label, onClick }: MenuItemProps) => {
  const theme = useTheme();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={{
        px: 3,
        py: 1.5,
        cursor: 'pointer',
      }}
    >
      <Text
        variant="body2"
        sx={{
          fontWeight: '700',
          color: isHovered
            ? theme.palette.primary.main
            : theme.palette.text.secondary,
        }}
      >
        {label}
      </Text>
    </Box>
  );
};
